import { string, object } from 'prop-types'
import { connect } from 'react-redux'
import { assetProxyImageUrl } from '@opallabs/routing'
import { jsonApiWrapper } from '@opallabs/wormhole'
import ImageSlideThumbnail from './ImageSlideThumbnail'
import TextImageSlideThumbnail from './TextImageSlideThumbnail'
import TextSlideThumbnail from './TextSlideThumbnail'

const SlideThumbnail = (props) => {
  const { layout } = props
  const theme = props.theme === null ? {} : props.theme
  const sanitizedProps = { ...props, theme }

  switch (layout) {
    case 'section_header':
    case 'basic_text':
      return <TextSlideThumbnail {...sanitizedProps} />
    case 'image_only':
      return <ImageSlideThumbnail {...sanitizedProps} />
    case 'text_and_image':
      return <TextImageSlideThumbnail {...sanitizedProps} />
    default:
      return null
  }
}

SlideThumbnail.propTypes = {
  layout: string,
  theme: object,
}

const mapStateToProps = (state, props) => {
  let additionalProps

  if (state.jsonApiEntities && state.jsonApiEntities.slide) {
    const slide = state.jsonApiEntities.slide[props.slideId]
    const { canvas_asset_reference, background_asset_reference } =
      jsonApiWrapper({ data: slide, state }) || {}
    let backgroundImageUrl

    if (background_asset_reference && background_asset_reference.uuid) {
      backgroundImageUrl = assetProxyImageUrl({
        uuid: background_asset_reference.uuid,
      })
    }

    additionalProps = {
      ...slide,
      assetReference: canvas_asset_reference || props.assetReference,
      backgroundImageURL: backgroundImageUrl || props.backgroundImageURL || '',
    }
  }

  return additionalProps || {}
}

const mapDispatchToProps = () => ({})

const ConnectedSlideThumbnail = connect(
  mapStateToProps,
  mapDispatchToProps
)(SlideThumbnail)

export default ConnectedSlideThumbnail
